const path = "/rh/pessoa-rh";
const pathMatricula = "/rh/matricula";
export default {
  main: path,
  matricula: pathMatricula,
  busca: `${path}/buscar`,
  alterarEmail: `${path}/alterar-email`,
};
